import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Sets document dir and lang attributes based on the current i18n language.
 * Call once near the root of the app.
 */
export function useDirection() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language

    const handleLanguageChanged = (lng: string) => {
      document.documentElement.lang = lng
    }

    i18n.on('languageChanged', handleLanguageChanged)
    return () => {
      i18n.off('languageChanged', handleLanguageChanged)
    }
  }, [i18n])
}
